const initialState = {
  empresas: [],
  empresaSelecionada: '',
  carregandoLista: false,
  carregandoGravacao: false,
  erro: null,
  load: {}
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'PDCA_SETUP_SET_EMPRESAS':
      return {
        ...state,
        empresas: payload
      }

    case 'PDCA_SETUP_SET_EMPRESA_SELECIONADA':
      return {
        ...state,
        empresaSelecionada: payload || ''
      }

    case 'PDCA_SETUP_SET_CARREGANDO_LISTA':
      return {
        ...state,
        carregandoLista: payload
      }

    case 'PDCA_SETUP_SET_CARREGANDO_GRAVACAO':
      return {
        ...state,
        carregandoGravacao: payload
      }

    case 'PDCA_SETUP_SET_ERRO':
      return {
        ...state,
        erro: payload
      }

    case 'PDCA_SETUP_RESET':
      return {
        ...initialState
      }

    case 'PDCA_SETUP_SET_LOAD':
      return {
        ...state,
        load: {
          [payload.name]: payload.value
        }
      }

    default:
      return state
  }
}